module.exports = __webpack_public_path__ + "img/login-bg.bb2a530e.jpg";